import { render, staticRenderFns } from "./WelcomeTwismConnections.vue?vue&type=template&id=03506e00&scoped=true&"
import script from "./WelcomeTwismConnections.vue?vue&type=script&lang=ts&"
export * from "./WelcomeTwismConnections.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeTwismConnections.vue?vue&type=style&index=0&id=03506e00&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03506e00",
  null
  
)

export default component.exports